export const initialDevisCreateDevis = 
{
    clientIri: "",
    region: "",
    categoryType: ""
}